module.exports = __webpack_public_path__ + "static/media/mck.86d733bc.png";